import { useCallback } from 'react';
import { get, camelCase } from 'lodash';

import hearingIcon from '../../../../../../assets/hearing.svg';
import { useHealthCheck } from '../../../../../../hooks/healthCheck';
import { Question } from '../../../../../../models/question';
import { AnswerCard } from '../../../AnswerCard';
import { AudioGramExams } from './fields/AudiogramExams';
import {
  QuestionnaireHeader,
  QuestionnaireIcon,
  QuestionnaireTitle,
  QuestionnaireWrapper,
  QuestionsWrapper
} from './styles';

interface HearingProps {
  questions: Question[];
}

export const Hearing = ({ questions }: HearingProps) => {
  const { bodyAnswers, answeredBodyQuestions } = useHealthCheck();

  const isQuestionnaireComplete = useCallback(
    (questionnaire: string) => {
      const isComplete = get(
        answeredBodyQuestions,
        camelCase(questionnaire),
        false
      );

      return isComplete;
    },
    [answeredBodyQuestions]
  );

  return (
    <QuestionnaireWrapper
      isComplete={isQuestionnaireComplete('Hearing Screen')}
    >
      <QuestionnaireHeader>
        <QuestionnaireIcon>
          <img src={hearingIcon} alt="hearing icon" />
        </QuestionnaireIcon>

        <QuestionnaireTitle>Hearing Screen</QuestionnaireTitle>
      </QuestionnaireHeader>

      <QuestionsWrapper>
        {questions
          .sort((a, b) => (a.order > b.order ? 1 : -1))
          .map((question, questionIndex) => (
            <AnswerCard
              key={question.id}
              answers={bodyAnswers}
              questionIndex={questionIndex}
              question={question}
            />
          ))}
        <AudioGramExams />
      </QuestionsWrapper>
    </QuestionnaireWrapper>
  );
};
